/* eslint-disable */
import { useEffect } from "react"

interface Props {
  apiKey: string
  customer_id: string
}
const FidoScript: React.FC<Props> = ({ apiKey, customer_id }) => {
  useEffect(() => {
    console.log("fido script is running")
    ;(function (f: any, i, d, o, c, od?: any, e?: any) {
      f["FidoObject"] = c
      ;(f[c] =
        f[c] ||
        function () {
          ;(f[c].q = f[c].q || []).push(arguments)
        }),
        (f[c].l = Number(new Date() as any))
      ;(od = i.createElement(d)), (e = i.getElementsByTagName(d)[0])
      od.async = 1
      od.src = o
      e.parentNode.insertBefore(od, e)
    })(
      window,
      document,
      "script",
      process.env.REACT_APP_FIDO_JS_SIGNUP_URL,
      "fido",
    )
    const _fido = (window as any).fido
    _fido("create", apiKey)
    _fido("auto_capture", false)
    _fido("customer_id", customer_id)
    _fido("claims", ["browser"])
  }, [])
  return null
}
export default FidoScript
